import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Box,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  HStack,
  Img,
  Button,
  Image,
  MenuItem,
  MenuList,
  MenuButton,
  Menu,
  useDisclosure,
  Skeleton,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { formatTableValue } from "./formatTable";
import chevronLeft from "../../assets/images/employee/chevron-left.svg";
import chevronRight from "../../assets/images/employee/chevron-right.svg";
import useDebounce from "../../hooks/useDebounce";
import ReactPaginate from "react-paginate";
import iconDetail from "../../assets/images/contract/Frame (1).svg";
import { AiOutlineMore } from "react-icons/ai";
import FormDetail from "./form/detail";
import FormInfo from "./form/info";
import { useCategories } from "../../categorys/locking/index";
import toast from "react-hot-toast";
import { lockingCall } from "../../api/locking";
import { lockingImageCall } from "../../api/lockingImage";
import { lockingParticipantCall } from "../../api/lockingParticipant";
import { useSearchParams } from "react-router-dom";
import { useLockingStatement } from "../../hooks/useLookingStatement";
import SearchableSelect from "../../components/selectForm";
import DatePicker from "react-datepicker";
import SearchableSelectMulti from "../../components/selectForm/mutiSelect";
import { GetTtkqHdmbs } from "../../utils/contants";
import calendarIcon from "../../assets/images/onleave/calendar.svg";

const TableLockingStatement = ({ isRefetchingWithCreate }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();

  const [searchParams] = useSearchParams();

  const employeeIdParam =
    searchParams.get("employee") || searchParams.get("employeeId");
  const saleAreaIdParam =
    searchParams.get("saleArea") || searchParams.get("saleAreaId");
  const saleBlockIdParam =
    searchParams.get("saleBlock") || searchParams.get("saleBlockId");
  const statusParam = searchParams.get("status");
  const branchIdParam = searchParams.get("branchId");
  const projectIdParam = searchParams.get("projectId");
  const startTimeParam = searchParams.get("startTime");
  const endTimeParam = searchParams.get("endTime");
  const agentIdParam = searchParams.get("agentId");

  const [search, setSearch] = useState("");
  const [isAddBooking, setIsAddBooking] = useState(false);
  const [dataEdit, setDataEdit] = useState(null);
  const [projectId, setProjectId] = useState([]);
  const [customerId, setCustomerId] = useState(null);
  const [agentId, setAgentId] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  // const [status, setStatus] = useState([]);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [isTtkqHdmbs, setIsTtkqHdmbs] = useState(null);
  const [apartmentId, setApartmentId] = useState([]);
  const [zIndex, setZIndex] = useState(1);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [saleBlockId, setSaleBlockId] = useState(null);
  const [saleAreaId, setSaleAreaId] = useState(null);

  const debouncedSearchTerm = useDebounce(search, 500);
  const onChangeSearch = useCallback((e) => {
    const { value } = e.target;
    setSearch(value);
  });

  const {
    lockingManagementData,
    refetch,
    isLoading,
    isRefetching,
    totalPages,
    setCurrentPage,
    currentPage,
    entries,
    startEntry,
    endEntry,
  } = useLockingStatement(
    debouncedSearchTerm,
    saleAreaId || null,
    saleBlockId || null,
    employeeId || null,
    null,
    branchIdParam || null,
    projectId || null,
    startDate || null,
    endDate || null,
    customerId,
    apartmentId,
    isTtkqHdmbs,
    agentId
  );

  // refech create
  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }
  const prevIsRefetchingWithCreate = usePrevious(isRefetchingWithCreate);

  useEffect(() => {
    if (
      isRefetchingWithCreate &&
      prevIsRefetchingWithCreate !== isRefetchingWithCreate
    ) {
      refetch();
    }
  }, [isRefetchingWithCreate, prevIsRefetchingWithCreate, refetch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldFetch(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  const { constantData } = useCategories(null, null, 1, shouldFetch);

  const formatEntries = (entries) =>
    Object.entries(entries || {}).map(([key, value]) => ({ key, value }));

  const projects = useMemo(
    () => formatEntries(constantData?.project),
    [constantData?.project]
  );

  const employees = useMemo(
    () => formatEntries(constantData?.employee),
    [constantData?.employee]
  );
  const apartments = useMemo(
    () => formatEntries(constantData?.apartments),
    [constantData?.apartments]
  );
  const customers = useMemo(
    () => formatEntries(constantData?.customer),
    [constantData?.customer]
  );

  const saleAreas = useMemo(
    () => formatEntries(constantData?.saleArea),
    [constantData?.saleArea]
  );
  const saleBlocks = useMemo(
    () => formatEntries(constantData?.saleBlock),
    [constantData?.saleBlock]
  );

  // const statusDatas = [
  //   {
  //     key: "NEW",
  //     value: "Chưa duyệt",
  //   },
  //   {
  //     key: "REJECTED",
  //     value: "Không được phê duyệt",
  //   },
  //   {
  //     key: "APPROVED",
  //     value: "Đã được duyệt",
  //   },
  //   {
  //     key: "REFUND",
  //     value: "Đã hoàn trả",
  //   },
  //   {
  //     key: "EDITING",
  //     value: "Yêu cầu chỉnh sửa",
  //   },
  // ];

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
    refetch();
  };

  const tableData = {
    headers: [
      {
        label: "",
        key: "",
      },
      {
        label: "STT",
        key: "",
      },
      {
        label: "Trạng thái",
        key: "status",
      },
      {
        label: "Đã lên TTKQ",
        key: "statusTtkq",
      },
      {
        label: "Đã lên HĐMB",
        key: "statusSalesContract",
      },
      {
        label: "Mã sản phẩm",
        key: "codeApartment",
      },
      {
        label: "Tên sản phẩm",
        key: "nameApartment",
      },
      {
        label: "Giá niêm yết",
        key: "totalValueApartment",
      },
      {
        label: "Giá tính phí dịch vụ ước tính",
        key: "estimatedServiceFeePrice",
      },
      {
        label: "Tên dự án",
        key: "nameProject",
      },
      {
        label: "Nhân viên tạo",
        key: "nameBooker",
      },
      {
        label: "Tên khối",
        key: "saleBlockName",
      },
      {
        label: "Mã khối",
        key: "saleBlockCode",
      },
      {
        label: "Tên vùng",
        key: "saleAreaName",
      },
      {
        label: "Mã vùng",
        key: "saleAreaCode",
      },
      {
        label: "Khách hàng",
        key: "nameCustomer",
      },
    ],
    data: lockingManagementData,
  };
  //
  // useEffect(() => {
  //   if (startTimeParam && endTimeParam) {
  //     const start = new Date(startTimeParam);
  //     const end = new Date(endTimeParam);
  //     setDateRange([start, end]);
  //   }
  // }, [startTimeParam, endTimeParam]);
  useEffect(() => {
    if (startTimeParam && endTimeParam) {
      const start = new Date(startTimeParam);
      const end = new Date(endTimeParam);
      setDateRange([start, end]);
    }
    if (saleBlockIdParam) setSaleBlockId(saleBlockIdParam);
    if (saleAreaIdParam) setSaleAreaId(saleAreaIdParam);
    if (employeeIdParam) setEmployeeId(employeeIdParam);
    if (agentIdParam) setAgentId(agentIdParam);
    if (projectIdParam && projects?.length) {
      const ids = projectIdParam.split(",").map((id) => id.trim());
      const selectedProjects = projects.filter((item) =>
        ids.includes(item.key)
      );
      const selectedIds = selectedProjects.map((item) => item.key);
      console.log(selectedIds);
      setProjectId(selectedIds);
    }
  }, [
    saleBlockIdParam,
    saleAreaIdParam,
    employeeIdParam,
    projectIdParam,
    projects,
    startTimeParam,
    endTimeParam,
  ]);

  const initialSelectedSaleBlock = useMemo(() => {
    if (!saleBlockIdParam || !saleBlocks?.length)
      return { key: 0, value: "Chọn khối" };
    // if (saleBlockIdParam) setSaleBlockId(saleBlockIdParam);
    return (
      saleBlocks.find((item) => item.key === saleBlockIdParam) || {
        key: 0,
        value: "Chọn khối",
      }
    );
  }, [saleBlockIdParam, saleBlocks]);

  const initialSelectedEmployee = useMemo(() => {
    if (!employeeIdParam || !employees?.length)
      return { key: 0, value: "Tất cả nhân viên" };
    // if (employeeIdParam) setEmployeeId(employeeIdParam);
    return (
      employees.find((item) => item.key === employeeIdParam) || {
        key: 0,
        value: "Tất cả nhân viên",
      }
    );
  }, [employeeIdParam, employees]);

  const initialSelectedSaleArea = useMemo(() => {
    if (!saleAreaIdParam || !saleAreas?.length)
      return { key: 0, value: "Chọn vùng" };
    // if (saleAreaIdParam) setSaleAreaId(saleAreaIdParam);
    return (
      saleAreas.find((item) => item.key === saleAreaIdParam) || {
        key: 0,
        value: "Chọn vùng",
      }
    );
  }, [saleAreaIdParam, saleAreas]);

  const initialSelectedProject = useMemo(() => {
    if (!projectIdParam || !projects?.length) return [];

    const ids =
      typeof projectIdParam === "string"
        ? projectIdParam.split(",").map((id) => id.trim())
        : [];

    const selectedProjects = projects.filter((item) => ids.includes(item.key));
    const selectedIds = selectedProjects.map((item) => item.key);
    // setProjectId(selectedIds);
    return selectedProjects.length > 0 ? selectedProjects : [];
  }, [projectIdParam, projects]);

  // console.log(initialSelectedProject)
  // table
  const handlePopup = (type, e) => {
    if (type) {
      setDataEdit(e?.edit);
    } else {
      setDataEdit(e?.detail);
    }

    setIsAddBooking(type);
    onOpen();
  };

  const onSubmitEdit = async (data) => {
    const toastCreate = toast.loading("Đang Sửa locking ...");
    try {
      let filteredData = Object.fromEntries(
        Object.entries(data).filter(
          ([_, value]) => value !== "" && value !== undefined && value !== null
        )
      );

      const { id, delegationImage, employeeProject, ...dataFilter } =
        filteredData;

      delete dataFilter?.delegationImage;
      delete dataFilter?.images;
      delete dataFilter?.errorImagePayment;
      delete dataFilter?.createdAt;

      if (id) {
        let createDataEmployeeManager = [];
        if (employeeProject) {
          createDataEmployeeManager = employeeProject.map((item) => {
            if (item?.id) {
              delete item?.id;
            }
            item.lockingId = id;
            return item;
          });
        }
        if (createDataEmployeeManager.length > 0) {
          await lockingParticipantCall.createAndUpdateMany({
            lockingId: id,
            list: createDataEmployeeManager,
          });
        }

        if (data?.delegationImage && data?.delegationImage.length > 0) {
          const paths = data?.delegationImage
            ?.filter((img) => img.path)
            .map((img) => img.path);

          await lockingImageCall.createMany({
            lockingId: id,
            path: paths,
            type: "TRANSACTION",
          });
        }
      }

      await lockingCall.update(id, {
        ...dataFilter,
      });

      await refetch();
      onToggle();
      onClose();
      toast.success("Sửa thành công");
    } catch (error) {
      console.log({ error });
      toast.dismiss(toastCreate);
    }
    toast.dismiss(toastCreate);
  };

  const submitStatus = async (status, id) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await lockingCall.approve(id, dataFormat);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  const revertStatus = async (status, id) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await lockingCall.revert(id, dataFormat);
      await refetch();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  return (
    <>
      <Flex flexDirection={"column"} gap={{ base: "16px" }}>
        <Flex
          backgroundColor="var(--color-main)"
          borderRadius={{ base: "12px" }}
          flexDirection={"column"}
        >
          <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            gap={{ base: "32px" }}
            p={"16px 16px 12px 16px"}
          >
            <Flex
              alignItems={"flex-start"}
              gap={{ base: "16px 32px" }}
              flex={"1"}
              flexDirection={"column"}
            >
              <InputGroup
                maxW="42vw"
                minW={"42vw"}
                borderRadius={{ base: "8px" }}
                w={{ base: "100%" }}
              >
                <Input
                  placeholder="Tên người tạo, khách hàng, sản phẩm, dự án "
                  type="text"
                  borderRadius={{ base: "8px" }}
                  border={{ base: "1px solid var(--color-boder)" }}
                  backgroundColor={"var(--fill-avatar)"}
                  onChange={onChangeSearch}
                />
                <InputRightElement
                  borderTopRightRadius={"8px"}
                  borderBottomRightRadius={"8px"}
                  pointerEvents="none"
                  cursor={"pointer"}
                  backgroundImage="var(--color-button)"
                >
                  <SearchIcon color="var(--color-main)" />
                </InputRightElement>
              </InputGroup>
              <Flex
                alignItems={"center"}
                gap={{ base: "16px 32px" }}
                flex={"1"}
                flexWrap={"wrap"}
                w={"100%"}
              >
                {/* <SearchableSelectMulti
                isShowSearch={false}
                options={statusDatas}
                // initialSelectedOption={{
                //   key: null,
                //   value: "Trạng thái locking",
                // }}
                placeholder={"Trạng thái locking"}
                setValue={setStatus}
              /> */}
                <SearchableSelect
                  // isShowSearch={true}
                  options={GetTtkqHdmbs}
                  initialSelectedOption={{
                    key: 0,
                    value: "Trạng thái lên TTKQ/HĐMB",
                  }}
                  setValue={setIsTtkqHdmbs}
                />
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={apartments}
                  // initialSelectedOption={[{ key: 0, value: "Chọn mã căn" }]}
                  placeholder={"Chọn mã căn"}
                  setValue={setApartmentId}
                />
                <SearchableSelectMulti
                  isShowSearch={true}
                  options={projects}
                  // initialSelectedOption={{ key: 0, value: "Chọn dự án" }}
                  placeholder={"Chọn dự án"}
                  initialSelectedOptionParam={[{ key: 0, value: "Chọn dự án" }]}
                  initialSelectedOption={initialSelectedProject}
                  setValue={setProjectId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={customers}
                  initialSelectedOption={{ key: 0, value: "Chọn khách hàng" }}
                  setValue={setCustomerId}
                />
                <InputGroup w={"100%"} maxW={"275px"} zIndex={zIndex}>
                  <DatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    dateFormat="dd/MM/yyyy"
                    locale="vi"
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    onFocus={() => {
                      setZIndex(3);
                    }}
                    onBlur={() => {
                      setZIndex(1);
                    }}
                    isClearable={true}
                    placeholderText="Ngày đặt cọc từ ngày - đến ngày"
                    className="datePickerStyle"
                  />
                  {!startDate && !endDate && (
                    <InputRightElement pointerEvents="none" h={"44px"}>
                      <Image src={calendarIcon} />
                    </InputRightElement>
                  )}
                </InputGroup>
                <SearchableSelect
                  isShowSearch={true}
                  options={employees}
                  initialSelectedOptionParam={{
                    key: 0,
                    value: "Chọn nhân viên tạo",
                  }}
                  initialSelectedOption={initialSelectedEmployee}
                  setValue={setEmployeeId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleBlocks}
                  // initialSelectedOption={{ key: 0, value: "Chọn khối" }}
                  initialSelectedOptionParam={{ key: 0, value: "Chọn khối" }}
                  initialSelectedOption={initialSelectedSaleBlock}
                  setValue={setSaleBlockId}
                />
                <SearchableSelect
                  isShowSearch={true}
                  options={saleAreas}
                  initialSelectedOptionParam={{ key: 0, value: "Chọn vùng" }}
                  initialSelectedOption={initialSelectedSaleArea}
                  setValue={setSaleAreaId}
                />
              </Flex>
            </Flex>
          </Flex>
          <Box width={"100%"} height={"100%"}>
            <Skeleton isLoaded={!isLoading && !isRefetching}>
              <TableContainer
                w={"100%"}
                maxH="calc(100vh - 350.5px)"
                overflowY="auto"
              >
                <Table w={"100%"} variant="unstyled">
                  <Thead
                    position="sticky"
                    top="0"
                    zIndex="1"
                    w={"100%"}
                    h={"41px"}
                    color="white"
                    fontWeight="400"
                    backgroundColor="#F9FAFD"
                  >
                    <Tr h={{ base: "41px" }}>
                      {tableData.headers.map((e, index) => {
                        let width = "auto";
                        let textAlign = "auto";
                        if (e.key === "") {
                          width = "2%";
                          textAlign = "center";
                        } else if (e.key === "code") {
                          width = "5%";
                          textAlign = "start";
                        } else if (e.key === "status") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "nameProject") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "saleOpeningEvent") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "booking") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "nameBooker") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "totalValueApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "estimatedServiceFeePrice") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "note") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "codeApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "nameApartment") {
                          width = "10%";
                          textAlign = "start";
                        } else if (e.key === "codeProduct") {
                          width = "10%";
                          textAlign = "start";
                        } else if (
                          e.key === "timeDelivery" ||
                          e.key === "timeStart" ||
                          e.key === "timeEnd"
                        ) {
                          width = "5%";
                          textAlign = "end";
                        } else {
                          width = "10%";
                          textAlign = "end";
                        }
                        return (
                          <Td
                            p={"16px 16px 8px 16px"}
                            key={index}
                            border={"none"}
                            color={"#51607B"}
                            fontSize={{ base: "14px" }}
                            w={width}
                          >
                            <Box textAlign={"center"} fontWeight={"bold"}>{e.label}</Box>
                          </Td>
                        );
                      })}
                    </Tr>
                  </Thead>
                  <Tbody w={"100%"} h={"100%"}>
                    {tableData.data?.length > 0 ? (
                      tableData.data?.map((e, rowIndex) => {
                        const items = { ...e };
                        delete items.id;
                        delete items.edit;
                        delete items.detail;
                        // delete items.statusSalesContract;
                        // delete items.statusTtkq;
                        delete items.is_allow_ttkq;
                        const keyValues = Object.keys(items);
                        return (
                          <Tr key={rowIndex} h={"72px"}>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              <Menu>
                                <MenuButton
                                  _hover={{ backgroundColor: "none" }}
                                  _active={{ backgroundColor: "none" }}
                                  background="none"
                                  as={Button}
                                >
                                  <AiOutlineMore fontSize={"20px"} />
                                </MenuButton>
                                <MenuList
                                  fontSize={{ base: "14px" }}
                                  fontWeight={500}
                                  lineHeight={"140%"}
                                  color={"var(--color-info-employee)"}
                                >
                                  <MenuItem
                                    gap={"16px"}
                                    onClick={() => handlePopup(false, e)}
                                  >
                                    <Image src={iconDetail} /> Xem chi tiết
                                  </MenuItem>
                                </MenuList>
                              </Menu>
                            </Td>
                            <Td p={"16px 16px 8px 16px"} w={"2%"}>
                              {rowIndex + 1}
                            </Td>
                            {keyValues.map((keyvalue, index) => {
                              let width = "auto";
                              let widthText = "100%";
                              let textAlign = "auto";
                              let whiteSpace = "inherit";
                              if (keyvalue === "") {
                                width = "2%";
                                textAlign = "center";
                              } else if (keyvalue === "code") {
                                width = "5%";
                                textAlign = "start";
                              } else if (keyvalue === "status") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "saleOpeningEvent") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "booking") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "nameBooker") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "estimatedServiceFeePrice") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "totalValueApartment") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "note") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "nameProject") {
                                width = "15%";
                                textAlign = "start";
                              } else if (keyvalue === "price") {
                                width = "10%";
                                textAlign = "end";
                              } else if (keyvalue === "bookingTime") {
                                width = "10%";
                                textAlign = "end";
                              } else if (keyvalue === "codeApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else if (keyvalue === "nameApartment") {
                                width = "10%";
                                textAlign = "start";
                              } else {
                                width = "10%";
                                textAlign = "end";
                                whiteSpace = "inherit";
                              }
                              return (
                                <Td
                                  p={"16px 16px 8px 16px"}
                                  w={width}
                                  key={index}
                                >
                                  <Box
                                    fontSize={{ base: "14px" }}
                                    lineHeight={"19.6px"}
                                    textAlign={"start"}
                                    fontWeight={500}
                                    color={"var(--color-info-employee)"}
                                    w={widthText}
                                    whiteSpace={whiteSpace}
                                    overflow="hidden"
                                    textOverflow="ellipsis"
                                    display="-webkit-box"
                                    sx={{
                                      WebkitLineClamp: "2",
                                      WebkitBoxOrient: "vertical",
                                    }}
                                  >
                                    {keyvalue === "status"
                                      ? formatTableValue(
                                          e[keyvalue],
                                          keyvalue,
                                          submitStatus,
                                          e.id,
                                          revertStatus
                                        )
                                      : formatTableValue(e[keyvalue], keyvalue)}
                                  </Box>
                                </Td>
                              );
                            })}
                          </Tr>
                        );
                      })
                    ) : (
                      <Tr>
                        <Td
                          colSpan={tableData.headers.length}
                          textAlign="center"
                          padding={"40px 0"}
                        >
                          Không có dữ liệu
                        </Td>
                      </Tr>
                    )}
                  </Tbody>
                </Table>
              </TableContainer>
            </Skeleton>
            <Box mt={10} mr={5} mb={5} ml={5}>
              <Flex alignItems={"center"} justifyContent={"space-between"}>
                <Text>
                  Showing {startEntry} to {endEntry} of {entries} entries
                </Text>
                <HStack spacing={2} justify="flex-end">
                  <ReactPaginate
                    className="pagination-custom"
                    pageCount={totalPages}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={1}
                    onPageChange={handlePageChange}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    breakClassName={"ellipsis"}
                    breakLabel={"..."}
                    previousLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronLeft}
                      />
                    }
                    nextLabel={
                      <Img
                        w={"16px"}
                        minW={"16px"}
                        h={"16px"}
                        src={chevronRight}
                      />
                    }
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                  />
                </HStack>
              </Flex>
            </Box>
          </Box>
        </Flex>
      </Flex>
      {isAddBooking ? (
        <FormDetail
          isOpen={isOpen}
          onClose={onClose}
          isEdit={true}
          defaultValues={dataEdit}
          onSubmit={onSubmitEdit}
        />
      ) : (
        <FormInfo
          isOpen={isOpen}
          onClose={onClose}
          defaultValues={dataEdit}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default TableLockingStatement;
